import React from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import storage from '@dashboard/services/storage';

import AuthLayout from '@dashboard/layouts/AuthLayout';

import Form from '@dashboard/components/Formik/Form';
import Link from '@dashboard/components/Link';
import Meta from '@dashboard/components/Meta';
import { GoogleSignIn } from '@dashboard/components/GoogleSignIn';
import { appUrl } from '@/dashboard/services/env';

export default function Login() {
  const { login, setLogged } = useAuth();
  const history = useHistory();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const redirectUrl = searchParams.get('redirect') || '/dashboard';

  const preserveQueryParams = baseUrl => {
    const currentSearch = window.location.search;
    const redirectTo = `${baseUrl}${currentSearch}`;

    return redirectTo;
  };

  return (
    <>
      <Meta
        meta={{
          title: 'Login',
        }}
      >
        <link rel="canonical" href={`${appUrl}/login`} />
      </Meta>

      <AuthLayout>
        <div className="text-center">
          <h1 className="text-4xl">Login to your account</h1>
          <h3 className="text-lg mt-2 font-normal mb-4">Enter your email and password to login</h3>
        </div>

        <div className="py-4">
          {/* Google Sign-In */}
          <div className="mb-6">
            <GoogleSignIn
              mode="login"
              onSuccess={result => {
                console.log('Google login success:', result);
              }}
              onError={error => {
                console.error('Google login error:', error);
              }}
            />
          </div>

          {/* Divider */}
          <div className="relative mb-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">Or continue with email</span>
            </div>
          </div>

          <Form
            initialValues={{
              email: '',
              password: '',
            }}
            onSubmit={async values => {
              const response = await login({
                ...values,
                session: storage.session.getItem('CheckoutPage.sessionId'),
              });

              return {
                data: response.data,
                error: response.error || response.message,
                onSuccess: () => {
                  setLogged({
                    user: response.data.user,
                    seller: response.data.user.seller,
                    token: response.data.token,
                  });

                  history.push(redirectUrl);
                },
              };
            }}
            showState={false}
            fields={[
              {
                name: 'email',
                required: true,
                type: 'email',
                label: 'Email',
                autocomplete: 'username',
              },
              {
                name: 'password',
                required: true,
                type: 'password',
                label: 'Password',
                autocomplete: 'current-password',
              },
            ]}
            submitButton={{
              label: 'Login',
              variant: 'primary',
              size: 'full',
            }}
          >
            <div className="flex justify-end">
              <Link to="/account/forgot-password" variant="secondary">
                Forgot password?
              </Link>
            </div>
          </Form>
        </div>

        <div className="text-center mt-4">
          {`Don't have an account?`}{' '}
          <Link href={preserveQueryParams('/signup')} variant="secondary">
            Sign up for free
          </Link>
        </div>
      </AuthLayout>
    </>
  );
}
